import { getWorkflowStep } from '~/core/application/workflow/utils';
import { useWorkflowSession } from '../../../contexts/WorkflowSessionContext';
import { WorkflowSet } from '../../../types';
import { useWorkflowSchema } from '../useWorkflowSchema';

export function useActiveWorkflow(): WorkflowSet | undefined {
  const { workflowName, place } = useWorkflowSession();

  const workflowSchema = useWorkflowSchema();

  const result: WorkflowSet | undefined =
    workflowName && place
      ? {
          workflow: workflowName,
          place,
          step: getWorkflowStep(workflowSchema, place),
        }
      : undefined;

  return result;
}
